module.exports = __webpack_public_path__ + "img/pianos.2c7c678.webp";